import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import InputMask from "react-input-mask-next";
import ReCAPTCHA from "react-google-recaptcha";
import { FaWhatsapp } from "react-icons/fa";
import BannerSlider from "./BannerSlider";

export default function LandingFinderUp() {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", company: "", status: "Novo" });
  const [submitted, setSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setFieldErrors({});

    const errors = {};

    if (!formData.name.trim()) errors.name = "Nome é obrigatório";
    if (!formData.email.trim()) {
      errors.email = "E-mail é obrigatório";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "E-mail inválido";
    }

    if (!formData.phone.trim()) {
      errors.phone = "Telefone é obrigatório";
    } else if (!/^\(\d{2}\) \d{5}-\d{4}$/.test(formData.phone)) {
      errors.phone = "Telefone inválido";
    }

    if (!formData.company.trim()) errors.company = "Nome da empresa é obrigatório";
    if (!recaptchaToken) errors.recaptcha = "Confirme que você não é um robô";

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }

    setIsSubmitting(true);
    try {
      await addDoc(collection(db, "leads"), {
        ...formData,
        origin: "finderup",
        timestamp: new Date(),
      });
      setSubmitted(true);
    } catch (error) {
      console.error("Erro ao enviar dados para o Firebase:", error);
      setErrorMessage("Não foi possível enviar os dados. Tente novamente mais tarde.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({ name: "", email: "", phone: "", company: "" });
    setRecaptchaToken(null);
    setFieldErrors({});
    setSubmitted(false);
  };

  const openWhatsApp = () => {
    window.open("https://wa.me/5516997640025", "_blank");
  };

  const inputStyles = "w-full border border-gray-600 bg-gray-800 text-white p-3 rounded-lg";

  return (
    <>
      <BannerSlider />
      <div className="min-h-screen bg-gray-900 text-white p-4 flex items-center justify-center">
        <div className="bg-gray-800 shadow-xl rounded-2xl p-6 sm:p-8 max-w-5xl w-full grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <div className="space-y-6">
            <img src="/logo2Finderup2.png" alt="Finder Up Logo" className="h-8 sm:h-10" />
            <h1 className="text-2xl sm:text-3xl font-bold leading-snug">Chega de Planilhas e Soluções Improvisadas</h1>
            <p className="text-base sm:text-lg leading-relaxed">
              Ganhe controle, agilidade e eficiência com um sistema feito sob medida para sua realidade.
            </p>
            <button
              onClick={openWhatsApp}
              className="w-full sm:w-auto flex items-center justify-center gap-2 bg-teal-500 text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-xl font-semibold hover:bg-teal-600 transition"
            >
              <FaWhatsapp className="text-lg sm:text-xl" />
              Fale com um especialista
            </button>
            <ul className="list-disc pl-5 sm:pl-6 space-y-2 text-sm text-gray-300">
              <li>Transformamos ideias em software funcional e intuitivo</li>
              <li>Do código ao crescimento: tecnologia sob medida para seu negócio</li>
              <li>Software eficiente, escalável e com suporte de verdade</li>
            </ul>
          </div>

          <div className="bg-gray-700 p-4 sm:p-6 rounded-xl shadow-inner space-y-4">
            <h2 className="text-lg sm:text-xl font-semibold text-center">
              {submitted ? "Agradecemos seu interesse!" : "Prefere que a gente entre em contato com você?"}
            </h2>

            {submitted ? (
              <div className="text-center space-y-4">
                <p className="text-green-400 font-semibold">Obrigado! Entraremos em contato em breve.</p>
                <p className="text-sm text-gray-300">Se preferir, fale conosco agora mesmo no WhatsApp! 💬</p>
                <div className="flex justify-center">
                  <button
                    onClick={openWhatsApp}
                    className="flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-lg font-semibold hover:bg-green-600 transition"
                  >
                    <FaWhatsapp className="text-lg" />
                    Enviar mensagem
                  </button>
                </div>
                <div className="pt-4">
                  <button
                    onClick={resetForm}
                    className="text-sm text-gray-400 underline hover:text-white"
                  >
                    Voltar ao formulário
                  </button>
                </div>
              </div>
            ) : (
              <form className="space-y-4" onSubmit={handleSubmit} autoComplete="off">
                <div>
                  <input
                    type="text"
                    name="name"
                    placeholder="Nome"
                    value={formData.name}
                    onChange={handleChange}
                    className={inputStyles}
                    required
                  />
                  {fieldErrors.name && <p className="text-red-400 text-sm">{fieldErrors.name}</p>}
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="E-mail"
                    value={formData.email}
                    onChange={handleChange}
                    className={inputStyles}
                    required
                  />
                  {fieldErrors.email && <p className="text-red-400 text-sm">{fieldErrors.email}</p>}
                </div>
                <div>
                  <InputMask
                    mask="(99) 99999-9999"
                    maskchar={null}
                    name="phone"
                    placeholder="Telefone (xx) xxxxx-xxxx"
                    value={formData.phone}
                    onChange={handleChange}
                  >
                    <input className={inputStyles} required />
                  </InputMask>
                  {fieldErrors.phone && <p className="text-red-400 text-sm">{fieldErrors.phone}</p>}
                </div>
                <div>
                  <input
                    type="text"
                    name="company"
                    placeholder="Nome da empresa"
                    value={formData.company}
                    onChange={handleChange}
                    className={inputStyles}
                    required
                  />
                  {fieldErrors.company && <p className="text-red-400 text-sm">{fieldErrors.company}</p>}
                </div>
                <div className="flex justify-center">
                  <div className="max-w-full overflow-hidden scale-[0.95] sm:scale-100">
                    <ReCAPTCHA
                      sitekey="6LdRCWArAAAAAEPY0P6VXwIQgRiuq2dZLjDovdJY"
                      onChange={(token) => setRecaptchaToken(token)}
                      theme="dark"
                    />
                  </div>
                </div>
                {fieldErrors.recaptcha && <p className="text-red-400 text-sm">{fieldErrors.recaptcha}</p>}
                {errorMessage && <p className="text-red-400 text-sm">{errorMessage}</p>}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-teal-500 text-white py-3 rounded-lg font-semibold hover:bg-teal-600 transition disabled:opacity-50"
                >
                  Enviar
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
}